import { useState, useEffect } from 'react';

const PixelMascot = () => {
  const [shouldBlink, setShouldBlink] = useState(false);

  useEffect(() => {
    // Random blink every 3-5 seconds
    const blinkInterval = setInterval(() => {
      setShouldBlink(true);
      setTimeout(() => setShouldBlink(false), 200);
    }, 3000 + Math.random() * 2000);

    return () => clearInterval(blinkInterval);
  }, []);

  return (
    <div className="relative w-64 h-64 flex items-center justify-center">
      {/* Browser Window */}
      <div className="relative">
        {/* Window Title Bar */}
        <div className="bg-primary-blue border-2 border-deep-navy p-2 flex items-center justify-between mb-0">
          <div className="flex gap-2">
            <div className="w-3 h-3 bg-charcoal border border-deep-navy"></div>
            <div className="w-3 h-3 bg-charcoal border border-deep-navy"></div>
            <div className="w-3 h-3 bg-charcoal border border-deep-navy"></div>
          </div>
        </div>

        {/* Window Content */}
        <div className="bg-deep-navy border-2 border-deep-navy w-64 h-48 flex flex-col items-center justify-center relative">
          {/* Eyes */}
          <div className={`flex gap-8 mb-4 transition-opacity duration-100 ${shouldBlink ? 'opacity-0' : 'opacity-100'}`}>
            <div className="w-4 h-4 bg-light-blue border border-light-blue"></div>
            <div className="w-4 h-4 bg-light-blue border border-light-blue"></div>
          </div>

          {/* Mouth/Line */}
          <div className="w-20 h-1 bg-light-blue mb-6"></div>

          {/* X204 Text */}
          <div className="text-pixel-xl text-light-blue font-pixel">
            X204
          </div>

          {/* Wave Hand - Left Side */}
          <div className="absolute -left-12 top-1/2 -translate-y-1/2">
            <div className="relative w-12 h-16">
              {/* Arm */}
              <div className="absolute left-0 top-4 w-8 h-2 bg-light-blue border border-primary-blue"></div>
              {/* Hand waving */}
              <div className="absolute left-6 top-2 w-4 h-6 bg-light-blue border border-primary-blue animate-pulse"></div>
            </div>
          </div>

          {/* Wave Hand - Right Side */}
          <div className="absolute -right-12 top-1/2 -translate-y-1/2">
            <div className="relative w-12 h-16">
              {/* Arm */}
              <div className="absolute right-0 top-4 w-8 h-2 bg-light-blue border border-primary-blue"></div>
              {/* Hand waving */}
              <div className="absolute right-6 top-2 w-4 h-6 bg-light-blue border border-primary-blue animate-pulse"></div>
            </div>
          </div>
        </div>

        {/* Window Stand/Legs */}
        <div className="flex justify-center gap-16 mt-0">
          <div className="w-16 h-12 bg-light-blue border-2 border-primary-blue"></div>
          <div className="w-16 h-12 bg-light-blue border-2 border-primary-blue"></div>
        </div>
      </div>
    </div>
  );
};

export default PixelMascot;